export default __webpack_public_path__ + "static/media/glados.b1025fef.png";